<div class="c-panel">
    <div class="panel-title">
        <span>{{stepNumber}}</span>
        <p>{{'select.race' | translate}}</p>
    </div>
    <div class="c-panel-ctn">
        @for (race of races; track $index) {
        <div class="c-panel-item"
            matRipple 
            [matRippleCentered]="rippleOptions.centered"
            [matRippleDisabled]="rippleOptions.disabled"
            [matRippleUnbounded]="rippleOptions.unbounded"
            [matRippleRadius]="rippleOptions.radius"
            [matRippleColor]="rippleOptions.color"
         [class.selected]="isRaceSelected(race.id)" (click)="selectRace(race.id)">
            <div class="race">{{'race.symbol' | translate}}{{ race.id }}</div>
            <div class="details">
                <h2>{{ race.name }}</h2>
                <p>{{ race.date | date:"HH:MM" }} - {{ race.type }} - {{ race.horses.length }} {{'horse.plural' | translate}} - {{ race.distance }}
                </p>
            </div>
        </div>
        }
    </div>
</div>
